import React, { useState, useRef } from 'react';
import { SvgIcon } from '../../calendar/components/svg-icon';
export const PromoCode = () => {
    const promoCodeData = window.promoCode;
    const [showInfo, setShowInfo] = useState(false);
    const [showError, setShowError] = useState(promoCodeData?.isError);
    const [showInvalid, setShowInvalid] = useState(promoCodeData?.isInvalid);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const promoForm = useRef(null);
    const promoInput = useRef(null);
    const handleSubmit = (e) => {
        if (promoInput?.current) {
            e.preventDefault();
            if (promoInput.current.value) {
                promoForm?.current?.submit();
                setIsSubmitting(true);
            }
            else {
                setShowError(true);
            }
        }
    };
    const handleChange = (e) => {
        if (showError && promoInput?.current?.value) {
            setShowError(false);
        }
        if (showInvalid) {
            setShowInvalid(false);
        }
    };
    return (<div className="pdp-promo-block">
            {promoCodeData.currentPromoCode == 'default' ?
            <form action={promoCodeData.actionPath} method="POST" className="stack-sm" onSubmit={handleSubmit} ref={promoForm} id="promoCodeBlock">
                        <div className="pdp-promo-label">
                            <label htmlFor="PromoCode_input">
                                {promoCodeData.promoCodeLabelText}
                            </label>
                            {!!promoCodeData.promoCodeDescription &&
                    <button type="button" className="btn-secondary icon-btn-sm icon-btn-borderless" onClick={() => setShowInfo(!showInfo)}>
                                    <SvgIcon iconId="icon-info"/>
                                    <span className="visually-hidden">More information</span>
                                </button>}
                        </div>
                        {!!promoCodeData.promoCodeDescription &&
                    <div className="pdp-promo-description" hidden={!showInfo} dangerouslySetInnerHTML={{ __html: promoCodeData.promoCodeDescription || "" }}/>}
                        <div className="inline-input-form">
                            <input type="text" name="PromoCode" id="PromoCode_input" ref={promoInput} onChange={handleChange} aria-describedby={showError ? 'PromoCode_error' : showInvalid ? 'PromoCode_invalid' : ''}/>
                            <button type="submit" className={`btn-custom ${isSubmitting ? 'btn-loader' : ''}`} disabled={isSubmitting}>{promoCodeData.promoCodeApply}</button>
                        </div>
                        {showError ?
                    <p className="error-message" id="PromoCode_error" dangerouslySetInnerHTML={{ __html: promoCodeData.promoCodeError || "" }}/>
                    :
                        showInvalid ?
                            <p className="error-message" id="PromoCode_invalid" dangerouslySetInnerHTML={{ __html: promoCodeData.promoCodeInvalid || "" }}/>
                            : null}
                        <input type="hidden" name="ReturnUrl" value={promoCodeData.returnUrl}/>
                    </form>
            :
                <form action={promoCodeData.actionPath} method="POST" className="stack-sm" onSubmit={() => setIsSubmitting(true)} id="promoCodeBlock">
                        <div className="flex-between">
                            <p className="bold">Promo Applied: {promoCodeData.currentPromoCode}</p>
                            <button type="submit" className="btn-link h6-style" disabled={isSubmitting}>Remove</button>
                        </div>
                        {!!promoCodeData.currentPromoDescription &&
                        <p className="small">{promoCodeData.currentPromoDescription}</p>}
                        <input type="hidden" name="ReturnUrl" value={promoCodeData.returnUrl}/>
                    </form>}
        </div>);
};
